import React, { useState } from "react";
import classnames from "classnames";
import { useFormikContext, useField } from "formik";
import { getIconForUID } from "components/FormerEditor/utils";
import { BUILDER_INTENT, BUILDER_ENTITY } from "utils/constants/builder";
import set from "lodash/set";
import get from "lodash/get";
import { STATE_KEYS } from "utils/constants/state";
import { useHoverProps } from "utils/hooks";

const AddEntityBlockItem = (props) => {
  const AddIcon = getIconForUID("add");
  const { values, setValues } = useFormikContext();
  const blockSettingsVisible = get(values, STATE_KEYS.EDITOR.VISIBILITY_PANEL);
  const { name } = props;

  const [_, meta] = useField(name);
  const { value } = meta;
  const active = value === BUILDER_ENTITY.ENTITY_ADD;
  const [hover, setHover] = useState();
  const hoverProps = useHoverProps({ hover, setHover });

  const containerProps = {
    className: classnames(
      "w-100 flex flex-row items-center pa3 top-0 left-0 right-0 bg-white bb b--black-05 sticky bh--inset pointer",
      {
        "bg-content--secondary": hover || active,
        "bg-white": !hover,
        "pointer": hover && !active
      }
    ),
    onClick: () => {
      const updatedValues = { ...values };
      set(updatedValues, STATE_KEYS.EDITOR.INTENT, BUILDER_INTENT.ENTITY_ADD);
      set(updatedValues, STATE_KEYS.EDITOR.VISIBILITY_PANEL, true);
      set(
        updatedValues,
        STATE_KEYS.EDITOR.ACTIVE_BLOCK,
        BUILDER_ENTITY.ENTITY_ADD
      );
      setValues(updatedValues);
    },
    ...hoverProps
  };

  return (
    <div {...containerProps}>
      <div
        style={{ height: 32, width: 32 }}
        className="flex items-center justify-center bg-black br2"
      >
        <AddIcon size={20} color="#ffffff" />
      </div>
      {!blockSettingsVisible && <div className="f5 pl2 fw5">Add block</div>}
    </div>
  );
};

export default AddEntityBlockItem;
